





















































import VueOptions from '@utils/VueOptions'

settings =
  name: "ShoppingCartSummary"

  vue:
    props: ['cart', 'activationPlans']

    computed:
      summary: -> @cart.summary

      samplingActivationPlans: ->
        (@activationPlans || []).filter((plan) ->
          isProductSampling = /_distribution/.test plan.line_items_info[0]?.item?.pricing_model
          isProductSampling
        )

export default VueOptions.vue settings
